"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Map = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Map = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "map", viewBox: "0 0 32 32", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsxs)("g", Object.assign({ id: "map", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M19.7 28.61 12 26.3 3 29V6l8.713-2.614c.2-.06.403-.054.588.004L20 5.7 29 3v23l-8.713 2.614a1.013 1.013 0 0 1-.596-.006l.007.002zM11 24.512V5.688l-6 1.8v18.824l6-1.8zm8 1.8V7.488l-6-1.8v18.824l6 1.8zm8-20.624-6 1.8v18.824l6-1.8V5.688z" }), (0, jsx_runtime_1.jsx)("path", { d: "M11 6 5 27l6-2zm16 0-6 21 6-2z", opacity: ".3" })] })) })));
};
exports.Map = Map;
